module.exports = __webpack_public_path__ + "img/lowerabs-endomorph-male.22bddcd8.svg";